import { css, CSSResult } from 'lit'
import { csBorder } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { csColorBorder } from '@cloudsuite/mosaic-shared/styles/colors.style.js'

export const cseAvatar = {
  borderRadius: css`var(--cse-avatar-border-radius, ${csBorder.radiusFull})`,
  borderColor: css`var(--cse-avatar-border-color, ${csColorBorder.light})`,
  borderWidth: css`var(--cse-avatar-border-width, 2px)`,
  smallSize: css`var(--cse-avatar-small-size, 32px)`,
  mediumSize: css`var(--cse-avatar-medium-size, 40px)`,
  largeSize: css`var(--cse-avatar-large-size, 64px)`,
  extraLargeSize: css`var(--cse-avatar-extra-large-size, 80px)`
}

export const style: CSSResult = css`
  .cse-avatar {
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    border: ${cseAvatar.borderWidth} solid ${cseAvatar.borderColor};
    border-radius: ${cseAvatar.borderRadius};
  }

  .size-small {
    width: ${cseAvatar.smallSize};
    height: ${cseAvatar.smallSize};
  }

  .size-medium {
    width: ${cseAvatar.mediumSize};
    height: ${cseAvatar.mediumSize};
  }

  .size-large {
    width: ${cseAvatar.largeSize};
    height: ${cseAvatar.largeSize};
  }

  .size-extra-large {
    width: ${cseAvatar.extraLargeSize};
    height: ${cseAvatar.extraLargeSize};
  }
`
